import { render, staticRenderFns } from "./CreatePricePackage.vue?vue&type=template&id=4febe9f1"
import script from "./CreatePricePackage.vue?vue&type=script&lang=js"
export * from "./CreatePricePackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports